import moment from 'moment-timezone';
import { useCallback, useEffect, useState } from 'react';

interface UseCalculateTimeLeftProps {
  endDateTime: string;
}

export const useCalculateTimeLeft = ({
  endDateTime,
}: UseCalculateTimeLeftProps) => {
  const calculateTimeLeft = useCallback(() => {
    const momentEndDateTime = moment(endDateTime);
    const momentNow = moment();

    const easternTimeEndDate = momentEndDateTime.tz('America/New_York');
    const now = momentNow.tz('America/New_York');
    const difference = easternTimeEndDate.diff(now);

    let timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.ceil((difference / 1000 / 60) % 60) - 1,
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  }, [endDateTime]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const isExpired =
    timeLeft.days === 0 &&
    timeLeft.hours === 0 &&
    timeLeft.minutes === 0 &&
    timeLeft.seconds === 0;

  useEffect(() => {
    if (endDateTime) {
      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft());
      }, 1000);

      return () => clearInterval(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endDateTime, calculateTimeLeft]);

  useEffect(() => {
    // Reset timeLeft when endDateTime changes
    setTimeLeft(calculateTimeLeft());
  }, [endDateTime, calculateTimeLeft]);

  return {
    timeLeft,
    isExpired,
  };
};
